export default {
  // ;; api-address
  baseUrl: "",
  defaultRoomCode: "",
};
